import React, { useContext, useReducer } from "react";
import useCBMouserOver from "../../../pages/CustomHooks/useCBMouserOver";
import { DesignAssetContext } from "../../../pages/CustomHooks/ContextApi";
import useProjectTypeValue from "../../../utils/useCurrentProjectValue";
import embLabels from "../../../config/emb-labels-en.json";
import ACTIONS from "../../../pages/DesignAssets/Design_Asset_Actions.json";
import  MyErrorBoundary from "../../../utils/ErrorBoundary";
const LoadPvBess = ({ loadLength, configured, isEVThere }) => {
  const {
    switchboardType,
    siteType,
    loadSelectHandler,
    loadSide,
    projectKind,
    coordinates: { busbarCordinates },
   count,
   isExportOptimization,
  } = useContext(DesignAssetContext);
    const projectTypeValue = useProjectTypeValue();
  const totalCount =
    typeof loadLength === "object" && loadLength !== null ? loadLength.loadCount : loadLength || 0;
  
  const  calculateXValue =(loadSide, projectKind, count)=> {
    if (loadSide === "LINE_SIDE") {
      if ( projectKind?.isMgaasAnsiGrid) {
        return count.derCount === 6
          ? 0
          :50;
      } 
      
    } 
  }
 const multipleLoadsAllowed = siteType === "GRID_CONNECTED" && isExportOptimization && ["NMGaaS ETO"].includes(projectTypeValue);

const  calculateValue = () => {

    if (count?.derCount === 6) {
      return 310;
    } else if (count?.derCount === 5) {
      return 250;
    } else if (count?.derCount === 4) {
      return 200;
    }else {
      return 120;
    }
}
const gridLimitExportOptimization  = () =>{
  if(siteType === "GRID_CONNECTED" && isExportOptimization && ["NMGaaS ETO"].includes(projectTypeValue)){
    return true;
  }else{
    return false;
  }

}
  return (
    <MyErrorBoundary>
      <>
        {[ "ISLANDABLE",  "GRID_CONNECTED"].includes(siteType) &&
        (switchboardType === "" ||
          switchboardType === embLabels.EXISTING_SWITCHBOARD) ? (
          <svg
            className="pointer"
            x={calculateXValue(loadSide, projectKind, count)}
            y={
                loadSide === "LOAD_SIDE"
                ?  "53"
                : "-8"
            }
          >
            <g id="CB1-load1">
              <svg
                width="70px"
                height="103px"
                viewBox="0 0 10 149"
                x={count?.derCount === 6
                  ?730
                  :count?.derCount === 5
                ?655
                :575
              }
                y={437}
                // onClick={loadCBSelectHandler}
              >
                <title>{"load Cb"}</title>
                <g
                  id="Circuit Breaker"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                >
                  <g
                    id="Circuit Breaker 1"
                    transform="translate(-651.000000, -512.000000)"
                  >
                    <g
                      id="Circuit Breaker - closed"
                      transform="translate(604.000000, 514.000000)"
                      // onMouseOver={CBMouseHandler}
                      // onMouseOut={CBMouseHandler}
                    >
                      <g
                        id="Group-15"
                        strokeWidth="4"
                        // fill={
                        //   load.CBSelected
                        //     ? "rgba(65, 181, 230, 0.35)"
                        //     : mouseOverData
                        //     ? "rgba(65, 181, 230, 0.35)"
                        //     : "none"
                        // }
                        // stroke={load.CBSelected ? "#42B4E6" : "none"}
                      >
                        <rect
                          id="Rectangle-Copy-20"
                          x="4"
                          y="8"
                          width="96"
                          height="124"
                        ></rect>
                        <g
                          id="Group-2"
                          transform="translate(48.000000, 0.000000)"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                          strokeWidth="4"
                        >
                          <line
                            x1="0.5"
                            y1="0"
                            x2="0.5"
                            y2="47.8298611"
                            id="Line-2"
                          ></line>
                        </g>
                      </g>
                      <line
                        x1="48.5"
                        y1="97.1701389"
                        x2="48.501111"
                        y2="145"
                        id="Line-2-Copy-15"
                        stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></line>
                      <path
                        d="M49,48.6645651 C56.9440104,64.554855 56.9440104,80.5555556 49,96.6666667"
                        id="Path-11"
                        stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                        strokeWidth="4"
                        strokeLinecap="round"
                      ></path>
                    </g>
                  </g>
                </g>
              </svg>
            </g>
            <g id="load11">
              <svg
                x={
                  count?.derCount === 6
                    ? 685
                    : count?.derCount === 5
                    ? 610
                    : 530
                }
                y={multipleLoadsAllowed?460:445}
                width="149px"
                height="475px"
                viewBox="0 0 90 550"
                onClick={loadSelectHandler}
              >
                <title>load</title>
                <g
                  id="Design"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                >
                  <g
                    id="Design/Assets-_-00"
                    transform="translate(-604.000000, -372.000000)"
                  >
                    <g
                      id="SLD/Production/Uniline/Undefined"
                      transform="translate(604.000000, 372.000000)"
                    >
                      <g id="SLD/Production/Uniline/Tobedefine">
                        <g id="Group-7">
                          <rect
                            id="Rectangle"
                            x="0"
                            y="95"
                            width="96"
                            height="148"
                          ></rect>

                          <line
                            x1="48.5"
                            y1={"95"}
                            x2="48.5"
                            y2="144"
                            id="Line-2"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                          ></line>

                          <circle
                            id="Oval"
                            stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                            strokeWidth="3"
                            cx="58"
                            cy="193.5"
                            r="45"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></circle>

                          <circle
                            id="Oval"
                            strokeWidth="3"
                            fill="var(--se-background-alternative)"
                            cx="48"
                            cy="193.5"
                            r="46.5"
                            stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                          ></circle>

                          <text
                            id="segment_energy_infra"
                            fontFamily="se-icon"
                            fontSize="56"
                            fontWeight="normal"
                            fill="var(--se-sld-circline)"
                          >
                            <tspan x="20" y="210">
                              segment_building_small
                            </tspan>
                          </text>
                        </g>
                      </g>
                      <g
                        id="999🔒Atoms/Notifications/Done"
                        transform="translate(75.000000, 160.000000)"
                      >
                        <g
                          id="999🔒Atoms/Background/Round"
                          strokeWidth="1"
                          fillRule="evenodd"
                          fill={configured ? "var(--se-sld-circline)" : "#E47F00"}
                          stroke="var(--se-background-alternative)"
                        >
                          <circle
                            id="Oval"
                            strokeWidth="2.66666667"
                            cx="16"
                            cy="16"
                            r={loadLength?.loadCount > 9 ? "20" : "18"}
                          ></circle>
                        </g>

                        <text
                          id="3"
                          fontFamily="Nunito-Regular, Nunito"
                          fontSize="21"
                          fontWeight="normal"
                          fill="var(--se-background-alternative)"
                        >
                          <tspan
                            x={loadLength?.loadCount < 10 ? "8" : "5"}
                            y="24"
                          >
                            {totalCount}
                          </tspan>
                        </text>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </g>
          </svg>
        ) : (
          <svg
            className="pointer"
            x={ calculateValue()}
            y={ ""  }
          >
            <g id="CB1-load1">
              <svg
                width="70px"
                height="103px"
                viewBox="0 0 10 149"
                x={155}
                y={300}
                // onClick={loadCBSelectHandler}
              >
                <title>{"load Cb"}</title>
                <g
                  id="Circuit Breaker"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                >
                  <g
                    id="Circuit Breaker 1"
                    transform="translate(-651.000000, -512.000000)"
                  >
                    <g
                      id="Circuit Breaker - closed"
                      transform="translate(604.000000, 514.000000)"
                      // onMouseOver={CBMouseHandler}
                      // onMouseOut={CBMouseHandler}
                    >
                      <g
                        id="Group-15"
                        strokeWidth="4"
                        // fill={
                        //   load.CBSelected
                        //     ? "rgba(65, 181, 230, 0.35)"
                        //     : mouseOverData
                        //     ? "rgba(65, 181, 230, 0.35)"
                        //     : "none"
                        // }
                        // stroke={load.CBSelected ? "#42B4E6" : "none"}
                      >
                        <rect
                          id="Rectangle-Copy-20"
                          x="4"
                          y="8"
                          width="96"
                          height="124"
                        ></rect>
                        <g
                          id="Group-2"
                          transform="translate(48.000000, 0.000000)"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                          strokeWidth="4"
                        >
                          <line
                            x1="0.5"
                            y1="0"
                            x2="0.5"
                            y2="47.8298611"
                            id="Line-2"
                          ></line>
                        </g>
                      </g>
                      <line
                        x1="48.5"
                        y1="97.1701389"
                        x2="48.501111"
                        y2="145"
                        id="Line-2-Copy-15"
                        stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></line>
                      <path
                        d="M49,48.6645651 C56.9440104,64.554855 56.9440104,80.5555556 49,96.6666667"
                        id="Path-11"
                        stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                        strokeWidth="4"
                        strokeLinecap="round"
                      ></path>
                    </g>
                  </g>
                </g>
              </svg>
            </g>
            <g id="load1">
              <svg
                x={110}
                y={ (projectTypeValue === "MGaaS ETO" &&  siteType === "GRID_CONNECTED" && isExportOptimization )?313:320}
                width="149px"
                height="475px"
                viewBox="0 0 90 550"
                onClick={loadSelectHandler}
              >
                <title>load</title>
                <g
                  id="Design"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                >
                  <g
                    id="Design/Assets-_-00"
                    transform="translate(-604.000000, -372.000000)"
                  >
                    <g
                      id="SLD/Production/Uniline/Undefined"
                      transform="translate(604.000000, 372.000000)"
                    >
                      <g id="SLD/Production/Uniline/Tobedefine">
                        <g id="Group-7">
                          <rect
                            id="Rectangle"
                            x="0"
                            y="95"
                            width="96"
                            height="148"
                          ></rect>

                          <line
                            x1="48.5"
                            y1={"96"}
                            x2="48.5"
                            y2="144"
                            id="Line-2"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                          ></line>

                          <circle
                            id="Oval"
                            stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                            strokeWidth="3"
                            cx={!gridLimitExportOptimization()?"50":"58"}
                            cy={!gridLimitExportOptimization()?"190":"193.5"}
                            r="45"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            fill=""
                          ></circle>

                        { gridLimitExportOptimization() && <circle
                            id="Oval"
                            strokeWidth="3"
                            fill="var(--se-background-alternative)"
                            cx="48"
                            cy="193.5"
                            r="46.5"
                            stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                          ></circle>
}
                          <text
                            id="segment_energy_infra"
                            fontFamily="se-icon"
                            fontSize="56"
                            fontWeight="normal"
                            fill="var(--se-sld-circline)"
                          >
                            <tspan x="20" y="210">
                              segment_building_small
                            </tspan>
                          </text>
                        </g>
                     { gridLimitExportOptimization() && <g
                          id="999🔒Atoms/Notifications/Done"
                          transform="translate(75.000000, 160.000000)"
                        >
                          <g
                            id="999🔒Atoms/Background/Round"
                            strokeWidth="1"
                            fillRule="evenodd"
                            fill={configured ? "var(--se-sld-circline)" : "#E47F00"}
                            stroke="var(--se-background-alternative)"
                          >
                            <circle
                              id="Oval"
                              strokeWidth="2.66666667"
                              cx="16"
                              cy="16"
                              r={loadLength?.loadCount > 9 ? "20" : "18"}
                            ></circle>
                          </g>

                          <text
                            id="3"
                            fontFamily="Nunito-Regular, Nunito"
                            fontSize="21"
                            fontWeight="normal"
                            fill="var(--se-background-alternative)"
                          >
                            <tspan
                              x={loadLength?.loadCount < 10 ? "8" : "5"}
                              y="24"
                            >
                              {totalCount}
                            </tspan>
                          </text>
                        </g>}
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </g>
          </svg>
        )}
      </>
    </MyErrorBoundary>
  );
};

export default LoadPvBess;
